import React, { FC } from "react";
import { Button, ButtonProps } from "react-toolbox/lib/button";
import { ProgressBar } from "react-toolbox/lib/progress_bar";

import spinnerTheme from "./loadingButtonTheme.scss";

export interface LoadingButtonProps extends ButtonProps {
    isLoading: boolean;
    icon?: string;
}
/**
 * A button with interaction display while loading.
 */
const LoadingButton: FC<LoadingButtonProps> = (props: LoadingButtonProps) => {
    const { disabled, isLoading, icon, ...buttonProps } = props;

    const iconProp = isLoading ? <ProgressBar type="circular" mode="indeterminate" theme={spinnerTheme} /> : icon;
    const disabledProp = isLoading ? true : disabled;

    return <Button disabled={disabledProp} icon={iconProp} {...buttonProps} />;
};

export { LoadingButton };
